export default "__VITE_IMAGE_ASSET__4b732563__";